import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { TenantProvider } from './context/TenantContext';
import { Onboarding } from './pages/Onboarding';
import { useOnboarding } from './hooks/useOnboarding';
import { Welcome } from './pages/Welcome';
import { Question } from './pages/Question';
import { Review } from './pages/Review';
import { Processing } from './pages/Processing';
import { Results } from './pages/Results';
import { Presenter } from './pages/Presenter';
import { Settings } from './pages/Settings';
import { WebinarHistory } from './pages/WebinarHistory';
import { SharedScript } from './pages/SharedScript';
import { SharedWebinar } from './pages/SharedWebinar';
import { LaunchPlanner } from './pages/LaunchPlanner';
import { WebinarStatus } from './pages/WebinarStatus';

function OnboardingGate({ children }: { children: React.ReactNode }) {
  const { needsOnboarding, loading } = useOnboarding();
  const location = useLocation();

  // Don't redirect on public routes, onboarding page itself, or while loading
  const isExcluded =
    location.pathname.startsWith('/script/') ||
    location.pathname.startsWith('/webinar/') ||
    location.pathname === '/onboard';

  if (isExcluded || loading) return <>{children}</>;

  if (needsOnboarding) {
    return <Navigate to={`/onboard${location.search}`} replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <TenantProvider>
        <div className="min-h-screen bg-background">
          <div className="fixed inset-0 -z-10 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary-900/20 via-background to-background" />
          <OnboardingGate>
            <Routes>
              <Route path="/script/:token" element={<SharedScript />} />
              <Route path="/webinar/:slug" element={<SharedWebinar />} />
              <Route path="/" element={<Welcome />} />
              <Route path="/question/:step" element={<Question />} />
              <Route path="/review" element={<Review />} />
              <Route path="/processing" element={<Processing />} />
              <Route path="/results/:id?" element={<Results />} />
              <Route path="/presenter" element={<Presenter />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/history" element={<WebinarHistory />} />
              <Route path="/launch/:id" element={<LaunchPlanner />} />
              <Route path="/status/:id" element={<WebinarStatus />} />
              <Route path="/onboard" element={<Onboarding />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </OnboardingGate>
        </div>
      </TenantProvider>
    </BrowserRouter>
  );
}

export default App;
